export class AlarmAction {
  constructor(
    public code: number,
    public name: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/alarm-action.ts